import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ColorUnitProps as Props } from './types';

export const ColorUnit = memo(
  ({ className, color, handleColorChange }: Props) => {
    const { hexCode, name, selected } = color;
    return (
      <Styled.Wrapper
        className={classnames('ColorUnit', className)}
        sx={SX.root}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        gap={1}
        onClick={() => handleColorChange(color.hexCode)}
      >
        <Stack
          sx={{ backgroundColor: hexCode, ...SX.colorBox }}
          justifyContent="center"
          alignItems="center"
        >
          <Icon name="tick" size={12} sxx={SX.selectedIcon(selected)} />
        </Stack>
        <Typography variant="body4" sx={{ cursor: 'pointer' }}>
          {name}
        </Typography>
      </Styled.Wrapper>
    );
  }
);

ColorUnit.displayName = 'ColorUnit';
